import {
  Component,
  OnInit,
  AfterViewChecked,
  Renderer2,
  ElementRef,
  Inject,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_CONFIG, AppConfig } from '@app/app-config.module';
import { filter, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from "../../node_modules/usermanagement-boothelp/src/app/core/services/menu.service"
import { MenuSearch } from '../../node_modules/usermanagement-boothelp/src/app/shared/models/menu.model';
import { lastValueFrom, of } from 'rxjs';
import { getNumberOfCurrencyDigits } from '@angular/common';
import { DigitalMailboxService } from './core/services/digital-mailbox.service';
import { AppConstant } from '@app/configs/app.constant';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Prompt Post';
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private renderer: Renderer2,
    private el: ElementRef,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService,
    public translate: TranslateService,
    public digitalMailboxService: DigitalMailboxService
  ) { 
    let lang = sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : this.config.defaultLanguage
    translate.addLangs(['EN', 'TH']);
    translate.setDefaultLang(lang);
    translate.use(lang);
  }

  async ngOnInit(): Promise<void> {
    const appTitle = this.titleService.getTitle();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          
          let child = this.route.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      )
      .subscribe((title: string) => {
        //console.log("IN CHECK ROUTE",  this.router.routerState.snapshot.url )
        this.titleService.setTitle(title);
        
        let targetUrl =  this.router.routerState.snapshot.url;
        // this.getProfileImg();
        this.checkMenuPermission(targetUrl)
          .then( (result) => {
            //console.log("DEBUG RESULT : ", result)
            if (result.success) {
              this.titleService.setTitle(title);
            } else {
              this.router.navigate(["/login"]);
            }
          })
          .catch( (err) => {
            console.error("Problem with checkMenuPermission : ", err)
            this.router.navigate(["/login"]);
          })
      });
  }

  ngAfterViewChecked(): void {
    if (this.router.url === '/auth/login') {      
      this.initADFSLogin();
      this.removeLoginForm();
      this.initTHPLogo();      
    }
  }

  initTHPLogo() {
    const node: NodeList = this.el.nativeElement.querySelectorAll(
      'img#signin-thp-logo-img'
    );

    if (node && !node.length) {
      const div: HTMLDivElement = this.renderer.createElement('div');
      this.renderer.addClass(div, 'text-center');

      const image: HTMLImageElement = this.renderer.createElement('img');
      this.renderer.addClass(image, 'thp_signin_logo_img');

      image.src = 'assets/img/logo-promptpost.png';
      image.width = 129;
      image.alt = ''; 

      const a = this.renderer.createElement('a');

      this.renderer.setAttribute(image, 'id', 'signin-thp-logo-img');
      this.renderer.addClass(image, 'my-2');
      this.renderer.addClass(image, 'text-center');
      this.renderer.appendChild(a, image);
      this.renderer.setStyle(a, 'min-width', 'auto');
      this.renderer.setStyle(a, 'background-color', '#fff');

      this.renderer.appendChild(div, a);

      this.renderer.insertBefore(
        this.el.nativeElement.querySelector('div.signin-block'),
        div,
        this.el.nativeElement.getElementsByClassName('card-body')[0]
      );
    }
  }

  initADFSLogin() {
    const node: NodeList = this.el.nativeElement.querySelectorAll(
      'button#oauth2-login-with-adfs'
    );

    try {
      if (node && !node.length) {

        this.signinToAdfs();

        const div: HTMLDivElement = this.renderer.createElement('div');        

        const button: HTMLButtonElement = this.renderer.createElement('button');
        const buttonText = this.renderer.createText('Login with ADFS account');

        'btn btn-danger rounded-pill mx-5 mb-5'
          .split(' ')
          .forEach((className: string) => {
            this.renderer.addClass(button, className);
          });

        this.renderer.setAttribute(button, 'id', 'oauth2-login-with-adfs');
        this.renderer.appendChild(button, buttonText);

        const hr = this.renderer.createElement('hr');

        'mt-0 text-danger'.split(' ').forEach((className: string) => {
          this.renderer.addClass(hr, className);
        });

        const elems = [div, button];

        elems.forEach((elem) => {
          const parent =
            this.el.nativeElement.getElementsByClassName('signin-block')[0];
          this.renderer.appendChild(parent, elem);
        });

        this.renderer.listen(button, 'click', () => this.signinToAdfs());
      }
    } catch (error) {}
  }

  signinToAdfs() {
    window.open(this.config.adfsEndpoint, '_self');
  }

  removeLoginForm() {
    if(this.el.nativeElement.querySelector('div.signin-block form')){
      this.el.nativeElement.querySelector('div.signin-block form').remove();
      
      const a = this.renderer.createElement('a');
      const text = this.renderer.createText('Forgot Password?');

      this.renderer.appendChild(a,text);

      'text-center text-link mb-5'
      .split(' ')
      .forEach((className: string) => {
        this.renderer.addClass(a, className);
      });

      this.renderer.setAttribute(a,'href','javascript:void(0);');  

      const elems = [a];

      elems.forEach((elem) => {
        const parent =
          this.el.nativeElement.getElementsByClassName('signin-block')[0];
        this.renderer.appendChild(parent, elem);
      });

      this.renderer.listen(a, 'click', () => this.gotoForgotPassword());

    }    
    
  }

  gotoForgotPassword() {    
    this.router.navigate(["/auth/forgotpassword"]);
  }

  async checkMenuPermission(targetUrl) {

    if (!sessionStorage.getItem("currentUser")) {
      return {
        success : true,
        errorMessage : null
      };
    }

    let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

    if (!currentUser.menuList || !currentUser.menuAll || !Array.isArray(currentUser.menuList) || !Array.isArray(currentUser.menuAll) ) {
      let menuData = await this.getMenuForAuthen();

      if (menuData.success) {

        currentUser.menuList = menuData.data.menuList;
        currentUser.menuAll = menuData.data.menuAll;
        sessionStorage.setItem("currentUser", JSON.stringify(currentUser));

      } else {
        return {
          success : false,
          errorMessage :  menuData.errorMessage
        }
      }
    }

    let foundInMenuAll = currentUser.menuAll.find( (menu) => {
      return targetUrl.startsWith(menu.url);
    });

    let foundInMenuList = currentUser.menuList.find( (menu) => {
      return targetUrl.startsWith(menu.url);
    })

    if (!foundInMenuAll) {
      return {
        success : true,
        errorMessage : null
      }
    }

    if (foundInMenuAll && !foundInMenuList) {

        return {
          success: false,
          errorMessage: "Not permission for this page"
        }
    } else {
      return {
        success : true,
        errorMessage: null
      }
    }
  }

  async getMenuForAuthen() {
    let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

    let menuSearch: MenuSearch = {
        gid : currentUser.gid,
        name: null,
        url: null
      };

      let responseMenuAll = await lastValueFrom(this.menuService.getMenuAll());
      let responseMenuList = await lastValueFrom(this.menuService.getMenuList(1, 9999, menuSearch));

      if (responseMenuAll.status == "success" && responseMenuList.status == "success") {
        return  { success : true , data : { menuAll : responseMenuAll.data,  menuList : responseMenuList.data  } , errorMessage : null  } 

      } else {
        return  { success : false, data : null , errorMessage : "Error when get menu" + responseMenuAll.message + " " + responseMenuList.message } ;
      }
  }

  getProfileImg(){
    this.digitalMailboxService.getProfileImage().subscribe({
      next: (res) => { 
        if (res.code == AppConstant.HTTP_STATUS_CODE_SUCCESS) { 
          if(res.data){ 
            sessionStorage.setItem("mailboxUser",JSON.stringify(res.data))
          }
        } else {
          console.log("error : ", res.message)
        }
      },
      error: (err) => {
        console.log(err); 
      }
    });
  } 

}
